import React from 'react';
import { Box, Fields } from 'modules/af_cm_ui_kit';
import fields, { FIELDS } from 'modules/cm/fields/types';

import { SectionProps } from './types';
import { Field } from 'formik';
import { VARIANTS_TYPES } from 'modules/af_cm_ui_kit/components/TextField/variants.types';

const AccountSection: React.FC<SectionProps> = ({ resources }) => {
  return (
    <Box title="Account">
      <Field
        component={Fields.Text}
        title={fields[FIELDS.ACCOUNT_NAME].label}
        name={fields[FIELDS.ACCOUNT_NAME].name}
      />

      <Field
        component={Fields.Text}
        title={fields[FIELDS.SORT_CODE].label}
        name={fields[FIELDS.SORT_CODE].name}
        variant={VARIANTS_TYPES.SORT_CODE}
      />

      <Field
        component={Fields.Text}
        title={fields[FIELDS.ACCOUNT_NUMBER].label}
        name={fields[FIELDS.ACCOUNT_NUMBER].name}
        variant={VARIANTS_TYPES.BANK_ACC_NUMBER}
      />

      <Field
        component={Fields.Text}
        title={fields[FIELDS.BANK_OR_BUILDING_SOCIETY_NAME].label}
        name={fields[FIELDS.BANK_OR_BUILDING_SOCIETY_NAME].name}
      />
    </Box>
  );
};

export default AccountSection;
